import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'

class homeStore {
    @observable loading
    @observable lists
    constructor (){
      this.loading = false;
      this.lists = [];
    }

  @action
  init = async () => {
    runInAction(()=>{
      this.loading = true;
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/categoryAndNews/e00e4e56-fdb2-11e7-aa35-2679ea2c1e10`)
    runInAction(()=>{
      this.loading = true;
      this.lists = res;
      this.loading = false;
    })

  }

}

export default new homeStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/homePage/content/Home/store.js